
<div class="" style="margin-left: 75px">
    <!-- site dialog -->
    <d-site
        v-model  = "showSite"
        :site-id = "siteId"
        :edit    = "editUnit"
        @saved   = "onUnitSaved"
    />
    <!-- site dialog -->

    <!-- customer preferences dialog -->
    <d-customer
        v-model   = "showTemplates"
        :customer = "customer.selected"
        :key      = "customer.selected ? customer.selected.id : 0"
    />
    <!-- template dialog -->

    <!-- recipients edit -->
    <recipients-edit
        v-model  = "recipients.edit"
        :company = "recipients.selected"
    />
    <!-- recipients edit -->

    <d-operator-dialog
        v-model   = "operator.edit"
        :customer = "customer.selected"
        @refresh  = "onRefreshOperator"
    />

    <d-customer-responsibilities
        v-model   = "showResponsibilities"
        :customer = "customer.selected"
    />

    <d-customer-bulk-update
        v-model = "bulkUpdate.show"
        :units  = "bulkUpdate.units"
        @done   = "onBulkUpdateDone"
    />

   <company-app-bar
        title="KUNDEN"
        :categories = "['customer']"
        @search     = "onSearch"
    >
       <template v-slot:toolbar>
           <c-toolbar-button
               icon     = "mdi-database-import"
               color    = "primary"
               :size    = "22"
               :tooltip = "$t('home.button')"
               class    = "ml-2"
               @click   = "onImport"
           />
       </template>
   </company-app-bar>

     <c-customer-index
        :minimize      = "false"
        :enable-search = "false"
        :criterion     = "criterion"
        @changed       = "onCustomer"
        style          = "padding-right: 75px;"
    >
        <template v-slot:detail="{ item }">
            <div v-if="item" class="mt-1" style="width: calc(100% + 12px);">
                <v-row class="no-frame">
                    <!-- companies -->
                    <v-col
                        class  = "no-frame ml-0 pl-3"
                        :class = "item.show ? 'pl-4' : 'pl-0'"
                        style  = "margin-top: 9px; padding-right: 10px!important;"
                    >
                        <company-edit
                            :company      = "customer.selected"
                            :height       = "410"
                            :comment-rows = "8"
                            :show-web     = "false"
                            style         = "margin-top: 9px;"
                        >
                            <template v-slot:toolbar>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <div class="pr-1">
                                            <a
                                                v-bind="attrs"
                                                v-on="on"
                                                @click.stop="onTemplate"
                                            >
                                                <v-icon size="17" class="pr-1 white--text">mdi-wrench</v-icon>
                                            </a>
                                        </div>
                                    </template>
                                    <span>Einstellungen bearbeiten</span>
                                </v-tooltip>
                            </template>
                            <template v-slot:additional>
                                <v-autocomplete
                                    dense
                                    chips
                                    :label="$t('msd.customer.responsibles.title')"
                                    multiple
                                    auto-select-first
                                    deletable-chips
                                    hide-no-data
                                    return-object
                                    v-model       = "customer.selected.responsibles"
                                    :items        = "users"
                                    :menu-props   = "menuProps"
                                    item-value    = "id"
                                    item-text     = "name"
                                    autocomplete  = "off"
                                    autocorrect   = "off"
                                    autocapitalize= "off"
                                    spellcheck    = "false"
                                    class         = "mt-4"
                                    append-icon   = ""
                                >
                                    <template v-slot:item="data">
                                        <v-list-item-content>
                                            <v-list-item-title class="component-title" v-html="data.item.name" />
                                        </v-list-item-content>
                                    </template>
                                    <template v-slot:selection="data">
                                        <v-chip
                                            v-if="data.index < 2"
                                            color        = "primary"
                                            style        = "margin: 1px"
                                            close-icon   = "mdi-close"
                                            @click:close = "onRemoveResponsible(data.item)"
                                            close
                                        >
                                            <div class="pl-1">
                                                <div class="selected-responsible">
                                                    {{ data.item.name }}
                                                </div>
                                                <div class="selected-responsible-email">
                                                    {{ data.item.email }}
                                                </div>
                                            </div>
                                        </v-chip>
                                        <span
                                            v-if="data.index === 2 && customer.selected.responsibles.length > 2"
                                            class="items-others"
                                        >(+ {{ customer.selected.responsibles.length - 2 }})</span>
                                    </template>
                                </v-autocomplete>

                                <div v-if="customer.selected.responsibles.length <= 1" style="height: 70px;">

                                </div>

                                <div v-if="customer.selected.responsibles.length > 1" class="v-flex">
                                    <div :style="isResponsibilityRefinement ? 'width: calc(100% - 30px)' : 'width: 100%'">
                                        <f-enum-select
                                            v-model   = "customer.selected.responsibilityType"
                                            label     = "Verantwortliche Liftmanager Zuordnung über ..."
                                            module    = "msd"
                                            type      = "customerResponsibilityType"
                                        />
                                    </div>
                                    <div style="width: 30px; margin-top: 25px" v-if="isResponsibilityRefinement">
                                        <c-toolbar-button
                                            color   = "primary"
                                            size    = "28"
                                            icon    = "mdi-clipboard-account"
                                            tooltip = "Liftmanager zuordnen"
                                            @click  = "onAssignLifties"
                                        />
                                    </div>
                                </div>
                            </template>
                        </company-edit>

                        <c-flip-card
                            v-if    = "isCompanyAndRecipientsVisible"
                            v-model = "flip"
                            color   = "white--text" :top="17" :right="90"
                            class   = "mt-1"
                            style   = "width: calc(100% + 10px); height: calc(100% - 500px);"
                        >
                            <template v-slot:front>
                                <c-card-iterator
                                    label          = "Betreiber"
                                    v-if           = "companies.items"
                                    :items         = "companies.items"
                                    :item-height   = "90"
                                    :filter-height = "79"
                                    :pagination-on = "true"
                                    :total-visible = "5"
                                    :min-height    = "553"
                                    class          = "w-100"
                                    :key           = "refreshOperator"
                                >
                                    <template v-slot:toolbar>
                                        <div class="pl-1" style="margin-top: -2px">
                                            <c-toolbar-button
                                                :size    = "24"
                                                icon     = "mdi-plus"
                                                color    = "white"
                                                :tooltip = "$t('msd.operator.create')"
                                                @click   = "onOperator"
                                            />
                                        </div>
                                    </template>
                                    <template v-slot:card="{ item }">
                                        <company-card
                                            style       = "width: calc(100% - 1px)"
                                            :company    = "item"
                                            :allow-edit = "true"
                                            @click      = "onOperatorSelect"
                                            @refresh    = "onRefreshOperator"
                                            :background = "operatorBackground (item)"
                                        />
                                    </template>
                                </c-card-iterator>
                            </template>
                            <template v-slot:back>
                                <c-recipient-card-iterator
                                    :customer-id = "customer.selected ? customer.selected.id : null"
                                    :top-space   = "553"
                                    @selected    = "onRecipient"
                                    class        = "w-100"
                                />
                            </template>
                        </c-flip-card>

                    </v-col>
                    <!-- companies -->

                    <!-- contacts -->
                    <v-col class="no-frame pl-1 pr-0">
                        <c-flip-card
                            v-if    = "item.item"
                            v-model = "flip"
                            color   = "white--text"
                            :top    = "17"
                            :right  = "80"
                        >
                            <template v-slot:front>
                                <c-contact-card-iterator
                                    :items       = "contacts.items"
                                    :contract-id = "contracts.selected ? contracts.selected.id : null"
                                    :company-id  = "operator.selected ? operator.selected.id : null"
                                    :customer-id = "customer.selected ? customer.selected.id : null"
                                    :combine-allowed = "true"
                                    mode         = "customer"
                                    @selected    = "onContact"
                                    class        = "w-100"
                                />
                            </template>
                            <template v-slot:back>
                                <c-contract-lim-card-iterator
                                    :contact-id   = "contacts.selected ? contacts.selected.id : null"
                                    :company-id   = "customer.selected ? customer.selected.id : null"
                                    :recipient-id = "recipients.selected ? recipients.selected.id : null"
                                    @selected     = "onContract"
                                    @renew        = "onRenew"
                                    class         = "w-100"
                                />
                            </template>
                        </c-flip-card>
                    </v-col>
                    <!-- contacts -->

                    <v-col class="no-frame pl-1">
                        <c-site-card-iterator
                            v-if             = "item.item"
                            class            = "w-100"
                            role             = "CUSTOMER"
                            :customer        = "item.item"
                            :contract        = "contracts.selected"
                            :contact         = "contacts.selected"
                            :contract-height = "contractHeight"
                            :allow-new       = "isUnitAdmin"
                            :allow-bulk-edit = "false"
                            @site            = "onSite"
                            @new-site        = "onNewSite"
                            @bulk-edit       = "onBulkUpdate"
                            ref              = "siteIterator"
                        >
                            <template v-slot:editor="{ site }">
                                <c-contract-lim-editor
                                    v-if  = "isLim"
                                    :unit = "site"
                                />
                                <c-contract-dls-editor
                                    v-if  = "isDls"
                                    :unit = "site"
                                />
                            </template>
                        </c-site-card-iterator>
                    </v-col>
                </v-row>
            </div>
        </template>
    </c-customer-index>
</div>
